<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__accessmanagement}">
      <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item label="">
          <wList v-model="dataForm.companyId"  type="1" dataUrl= "/sys/tscheduleaccount/getCompanyList" placeholder="公司名称"></wList>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t("query") }}</el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        @sort-change="dataListSortChangeHandle($event, false)"
        style="width: 100%"
      >
        <el-table-column
          prop="companyName"
          label="公司"
          header-align="center"
          align="center" 
        >
          <template slot-scope="scope">
            <div class="progress">
              <div
                :style="{
                  width: '100%',
                  background: scope.row.amtBalaval < money && 1 ? '#EC808D' : 'transparent',
                }"
              >
                {{ scope.row.companyName  }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="amtBalcur"
          label="账户余额（元）"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="amtBalfrz"
          label="冻结金额（元）"
          header-align="center"
          align="center"
          sortable="custom"
        ></el-table-column>
        <el-table-column
          prop="amtBalaval"
          label="闲置金额（元）"
          header-align="center"
          align="center"
          sortable="custom"
        >
          <template slot-scope="scope">
            <div class="progress">
              <div
                :style="{
                  width: '100%',
                  background: scope.row.amtBalaval < money && 1 ? '#EC808D' : 'transparent',
                }"
              >
                {{ setStyle(scope.row.amtBalaval) }}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle"
      >
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
    </div>
  </el-card>
</template>

<script>
import { getDictDataList } from '@/utils'
import mixinViewModule from "@/mixins/view-module";
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      mixinViewModuleOptions: {
        getDataListURL: "/sys/tscheduleaccount/page",
        getDataListIsPage: true,
        exportURL: "/sys/tscheduleaccount/export",
        deleteURL: "/sys/tscheduleaccount",
        deleteIsBatch: true,
      },
      money: '',
      dataForm: {
        id: "",
        companyId: "",
      },
    };
  },
  mounted(){
    this.money = getDictDataList('idlemoney')[0].dictValue
    // console.log(getDictDataList('idlemoney')[0].dictValue)
  },
  methods: {
    
    setStyle(v) {
      // console.log(this.$refs.progressChild)
      console.log(v);
      return v;
    },
  },
};
</script>
<style lang="scss" scoped>
.progress {
  height: 40px;
  width: 100%;
  overflow: hidden;
  > div {
    line-height: 40px;
  }
}

::v-deep .cell {
  padding: 0;
}
::v-deep .el-table td {
  padding: 0;
}
::v-deep .el-table .cell {
  padding: 0;
}
::v-deep .el-table--border td:first-child .cell,::v-deep .el-table--border th:first-child .cell{
  padding: 0;
 }
</style>